import { Checkbox } from '@/libs/components/src/lib/form/Checkbox';
import { Input } from '@chiroup/components/form/Input';
import { QuestionAnswer } from '@chiroup/core/types/ComplaintSummary.type';
import React from 'react';

interface HCCheckboxProps {
  questionId: string;
  questionData: QuestionAnswer;
  onAnswerChange: (questionId: string, newValue: string | string[], otherValue?: string) => void;
}

const HCCheckbox: React.FC<HCCheckboxProps> = ({ questionId, questionData, onAnswerChange }) => {
  const { options = [], selectedValues = [], otherValue } = questionData;

  // Check if any option has id 'other' to enable the includeOther prop
  const hasOtherOption = options.some(opt => opt.id === 'other');

  // Filter out the 'other' option from regular options since SurveyQuestionCheckbox handles it separately
  const regularOptions = options.filter(opt => opt.id !== 'other');

  const initialValue = selectedValues.reduce(
    (acc, val) => {
      acc[val] = val;

      return acc;
    },
    {} as { [key: string]: string }
  );

  const hasSelectedOther = selectedValues.includes('other');
  const canShowOtherToggle = hasOtherOption || hasSelectedOther;

  if (otherValue) {
    initialValue.other = 'other';
  }

  return (
    <div className="max-w-xs">
      {regularOptions.map(option => (
        <Checkbox
          key={option.id}
          label={option.display}
          value={selectedValues.includes(option.id)}
          onChange={value =>
            onAnswerChange(
              questionId,
              value
                ? selectedValues.concat(option.id)
                : selectedValues.filter(v => v !== option.id),
              otherValue
            )
          }
        />
      ))}
      {canShowOtherToggle && (
        <Checkbox
          label="Other"
          value={hasSelectedOther}
          onChange={value =>
            onAnswerChange(
              questionId,
              value ? selectedValues.concat('other') : selectedValues.filter(v => v !== 'other'),
              value ? otherValue : undefined
            )
          }
        />
      )}
      {hasSelectedOther && (
        <Input
          name={`edit-${questionId}-other`}
          type="text"
          value={otherValue}
          onChange={value => onAnswerChange(questionId, selectedValues, value)}
          className="w-48 primary"
        />
      )}
    </div>
  );
};

export default HCCheckbox;
